<template>
  <div :id="`ticket-reply-${reply.id}`">
    <bookmark-modal modelType="TicketReply" :modelId="reply.id"
      :currentValue="reply.bookmark"></bookmark-modal>

    <div class="card shadow-none">
      <div class="card-body" :class="{'pb-0': collapsed}">
        <!-- tl-wrapper -->
        <div class="tl-wrapper tl-header">
          <div class="tl-l">
            <div class="avatar-xs">
                            <span class="avatar-title rounded bg-soft-primary text-primary font-size-16">
                              {{ reply.agent.name.charAt(0) }}
                            </span>
            </div>
          </div>
          <div class="tl-r">
            <div>
              <span class="name">{{ reply.agent.name }}</span> replied
            </div>
            <small>
              <i>{{ displayTimestamp(reply.created_at) }}</i>
            </small>
          </div>
          <div class="tl-actions">
            <a href="#" class="btn btn-link text-muted" @click.prevent="toggleCollapsed">
              <i class="fa" :class="{'fa-chevron-down': collapsed, 'fa-chevron-up': !collapsed}"></i>
            </a>

            <a href="#" class="btn btn-link text-muted pl-1 pr-1" @click.prevent="openBookmarkModal">
              <i class="fa fa-heart" :class="{
                'text-danger': reply.bookmark
              }"></i>
            </a>

            <b-dropdown variant="white" right toggle-class="text-muted pt-0 pr-0 pb-0">
              <template v-slot:button-content>
                <i class="mdi mdi-dots-horizontal font-size-18"></i>
              </template>
              <b-dropdown-item @click="requestDelete" variant="danger">Delete</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <!-- / tl-wrapper -->
        <!-- tl-wrapper -->
        <div class="tl-wrapper tl-header" v-show="!collapsed">
          <div class="tl-l"></div>
          <div class="tl-r">
            <b class="mr-2">To:</b>
            <span class="mr-2" v-for="email in toAddresses">{{ email }}</span>
          </div>
        </div>
        <!-- / tl-wrapper -->
        <!-- tl-wrapper -->
        <div class="tl-wrapper tl-header" v-if="!collapsed && ccAddresses.length">
          <div class="tl-l"></div>
          <div class="tl-r">
            <b class="mr-2">Cc:</b>
            <span class="mr-2" v-for="email in ccAddresses">{{ email }}</span>
          </div>
        </div>
        <!-- / tl-wrapper -->
        <!-- tl-wrapper -->
        <div class="tl-wrapper tl-header" v-if="!collapsed && bccAddresses.length">
          <div class="tl-l"></div>
          <div class="tl-r">
            <b class="mr-2">Bcc:</b>
            <span class="mr-2" v-for="email in bccAddresses">{{ email }}</span>
          </div>
        </div>
        <!-- / tl-wrapper -->
        <!-- tl-wrapper -->
        <div class="tl-wrapper" v-show="!collapsed">
          <div class="tl-l"></div>
          <div class="tl-r" v-html="reply.body">
          </div>
        </div>
        <!-- / tl-wrapper -->
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import Dates from "../../../../../mixins/Dates";
import Forms from "../../../../../mixins/Forms";
import axios from "axios";
import eventBus from "../../../../../event-bus";
import BookmarkModal from './BookmarkModal.vue';

export default {
  props: ['reply'],
  name: "TicketReply",

  data() {
    return {
      collapsed: false
    }
  },

  created() {
    eventBus.$on('collapse-all', () => {
      this.collapsed = true;
    });
    eventBus.$on('expand-all', () => {
      this.collapsed = false;
    });
  },

  updated() {
    eventBus.$on("collapse-all", () => {
      this.collapsed = true;
    });
    eventBus.$on("expand-all", () => {
      this.collapsed = false;
    });
  },

  beforeDestroy() {
    eventBus.$off('collapse-all');
    eventBus.$off('expand-all');
  },

  computed: {
    ...mapGetters('ticketViewer', {
      ticket: 'ticket'
    }),

    toAddresses() {
      return JSON.parse(this.reply.to)
    },

    ccAddresses() {
      return JSON.parse(this.reply.cc)
    },

    bccAddresses() {
      return JSON.parse(this.reply.bcc)
    }
  },

  components: {BookmarkModal},

  mixins: [Dates, Forms],

  methods: {
    ...mapActions('ticketViewer', {
      reloadTicket: 'reloadTicket'
    }),

    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },

    openBookmarkModal() {
      this.$bvModal.show("bookmark-modal-TicketReply-" + this.reply.id);
    },

    requestDelete() {
      let vm = this;
      swal({
        title: "Are you sure you want to delete this note?",
        text: "This cannot be undone.",
        icon: "warning",
        buttons: {
          cancel: true,
          confirm: "Delete"
        },
        dangerMode: true,
      }).then((shouldDelete) => {
        if (shouldDelete) {
          vm.delete();
        }
      });
    },

    delete() {
      let vm = this;
      vm.isSaving = true;
      axios.delete(API_BASE + '/tickets/' + this.ticket.id + '/replies/' + this.reply.id).then(r => {
        vm.isSaving = false;
        vm.reloadTicket();
        this.$notify.success({
          title: 'Success!',
          message: 'Note deleted successfully'
        });
      }).catch(e => {
        vm.isSaving = false;
        vm.notifyErrors(e);
      });
    }
  }
}
</script>

<style scoped>
.card {
  background-image: linear-gradient(#fef1e1, #fef1e1);
}
</style>
